import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Builder from "./pages/builder";
import Pricing from "./pages/pricing";
import HowItWorks from "./pages/howitworks";
import Auth from "./pages/auth";
import Dashboard from "./pages/dashboard";
import JobTracker from "./pages/jobtracker";
import Contact from "./pages/contact";
import AccountSetting from "./pages/accountmanagement";
import PrivacyPolicy from "./pages/privacypolicy";
import Terms from "./pages/termsandconditions";
import DataSecurity from "./pages/datasecurity";
import ScrollToTop from "./components/scrolltotop";
import InterviewSimulator from "./pages/interviewsimulator";

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/builder" element={<Builder />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/tracker" element={<JobTracker />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/account" element={<AccountSetting />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/security" element={<DataSecurity />} />
        <Route path="/interviewsimulator" element={<InterviewSimulator />} />
      </Routes>
    </div>
  );
}

export default App;
